import React from 'react';
import { Row, Col, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { Link, RouteComponentProps } from 'react-router-dom';
import AuthSelectModal from './auth-select-modal';
import AuthAddToken from './auth-add-token';
import AuthAddSim from './auth-add-sim';
import CertInfoModal from './cert-info-modal';
import PasswordResetModal from './password-reset-modal';
import AuthAddPhone from './auth-add-phone';
import ItemAuth from './ItemAuth';
import AuthAddPasswordModal from './auth-add-password-modal';
import { connect } from 'react-redux';
import { Authenticator_Type, AUTHORIZE_SMART_CA, MESSAGE, SUCCESS } from 'app/config/constants';
import GroupPassAndSMS from './group-verify-pass-sms';
import GroupUSB from './group-usb';
import GroupKPI from './group-kpi';
import { getUrlParameter, Storage, translate } from 'react-jhipster';
import { IRootState } from 'app/shared/reducers';
import { signHashSmartCA } from '../../register/register.reducer';
import GroupSmartCA from './group-smartca';
import GroupEMAIL from './group-email';
import { reSendOtp } from 'app/modules/sendOtp/sendOtp.reducer';
import AuthEdit from './auth-edit';
import VerifyOtpEditAuth from './verify-otp-edit-auth';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import AuthAddApp from './auth-add-totp';
import { getQRCode } from '../user.reducer';
import GroupTOTP from './group-totp';
export interface IListAuthProps extends StateProps, DispatchProps, RouteComponentProps {
  listAuth: any;
  deleteAuth: Function;
  handleActive: Function;
  deleteGroup: Function;
  config: any;
  addAuthSmartCA: Function;
  // userProfile: any;
  search: Function;
}

export interface IListAuthState {
  showModalAdd: boolean;
  showAddToken: boolean;
  showAddSim: boolean;
  showCertInfo: boolean;
  showAddPhone: boolean;
  showAddApp: boolean;
  showAddPassword: boolean;
  showFormPhone: boolean;
  isAuthPassword: boolean;
  isAuthSMS: boolean;
  showOTP: boolean;
  id: any;
  value: any;
  showEditAuth: boolean;
  showFormOTP: boolean;
}

export class ListAuth extends React.Component<IListAuthProps, IListAuthState> {
  state: IListAuthState = {
    showModalAdd: false,
    showAddToken: false,
    showAddSim: false,
    showCertInfo: false,
    showAddPhone: false,
    showAddPassword: false,
    showAddApp: false,
    showFormPhone: true,
    isAuthPassword: false,
    isAuthSMS: false,
    showOTP: false,
    id: '',
    value: '',
    showEditAuth: false,
    showFormOTP: false
  };
  componentDidMount(): void {
    window.addEventListener('message', e => {
      if (e.data === 'close_modal_token') {
        this.setState({
          showModalAdd: false,
          showAddToken: false
        });
      }
    });
  }
  toggleAuthSelect = e => {
    e.preventDefault();
    let checkAuthPassword = this.checkAuthByType(Authenticator_Type.PASSWORD);
    let checkAuthSms = this.checkAuthByType(Authenticator_Type.SMS);
    this.setState(prevState => ({
      showModalAdd: !prevState.showModalAdd,
      isAuthPassword: checkAuthPassword != null && checkAuthPassword != '' && checkAuthPassword != 'undefined' ? true : false,
      isAuthSMS: checkAuthSms != null && checkAuthSms != '' && checkAuthSms != 'undefined' ? true : false
    }));
  };

  toggleAddToken = e => {
    this.setState(prevState => ({
      showModalAdd: false,
      showAddToken: !prevState.showAddToken
    }));
    //e.preventDefault();
  };

  toggleAddSim = e => {
    this.setState(prevState => ({
      showModalAdd: false,
      showAddSim: !prevState.showAddSim
    }));
    //e.preventDefault();
  };

  toggleCertInfo = e => {
    this.setState(prevState => ({
      showModalAdd: false,
      showAddSim: false,
      showAddToken: false
    }));
    //e.preventDefault();
  };

  toggleAddPhone = e => {
    this.setState(prevState => ({
      showModalAdd: false,
      showFormPhone: true,
      showAddPhone: false
    }));
    //e.preventDefault();
  };

  toggleEditAuth = e => {
    this.setState(prevState => ({
      showModalAdd: false,
      showEditAuth: false
    }));
  };

  toggleAddPassword = e => {
    this.setState({
      showModalAdd: false,
      showAddPassword: false
    });
  };

  openModalAddPhone = () => {
    this.setState({
      showModalAdd: false,
      showAddPhone: true
    });
  };

  openModalAddPassword = () => {
    this.setState(prevState => ({
      showModalAdd: false,
      showAddPassword: true
    }));
  };

  showFormOTP = () => {
    this.setState(prevState => ({
      showFormPhone: !prevState.showFormPhone
    }));
  };

  checkAuthByType = type => {
    const { listAuth } = this.props;
    let auth = null;
    if (listAuth && listAuth.authenticator) {
      auth = listAuth.authenticator.filter(item => item.type === type);
    }
    return auth;
  };

  closeModalVerifyOtp = () => {
    this.setState({
      showOTP: false
    });
  };

  verifyOtpSuccess = () => {
    this.setState({
      showOTP: false,
      showEditAuth: true
    });
  };

  sendOtp = id => {
    const type = id.indexOf('@') > 0 ? 'EMAIL' : 'SMS';
    this.props.reSendOtp(id, type, MESSAGE.OTP);
    this.setState({
      showOTP: true,
      id: id
    });
  };

  getArrPassAndSMS = () => {
    var arrTemp = [];
    var i;
    for (i = 0; i < this.props.listAuth.authenticator.length; i++) {
      if (
        this.props.listAuth.authenticator[i].type == Authenticator_Type.PASSWORD ||
        this.props.listAuth.authenticator[i].type == Authenticator_Type.SMS
      ) {
        arrTemp.push(this.props.listAuth.authenticator[i]);
      }
    }
    arrTemp.forEach(function(item, i) {
      if (item.type == Authenticator_Type.PASSWORD) {
        arrTemp.splice(i, 1);
        arrTemp.unshift(item);
      }
    });
    return arrTemp;
  };

  getArrEMAIL = () => {
    return this.props.listAuth.authenticator.filter(item => {
      return item.type == Authenticator_Type.EMAIL;
    });
  };

  getArrUSB = () => {
    return this.props.listAuth.authenticator.filter(item => {
      return item.type == Authenticator_Type.USB;
    });
  };

  getArrSmartCA = () => {
    return this.props.listAuth.authenticator.filter(item => {
      return item.type === Authenticator_Type.SMART_CA;
    });
  };

  getArrKPI = () => {
    return this.props.listAuth.authenticator.filter(item => {
      return item.type == Authenticator_Type.PKI;
    });
  };

  getArrTOTP = () => {
    return this.props.listAuth.authenticator.filter(item => {
      return item.type == Authenticator_Type.TOTP;
    });
  };

  searchAuth = (event, values) => {
    this.props.search(values.search);
  };

  handleAddApp = e => {
    this.props.getQRCode();
    this.setState({
      showModalAdd: false,
      showAddApp: true
    });
  };

  toggleAddApp = e => {
    this.setState(prevState => ({
      showModalAdd: false,
      showAddApp: !prevState.showAddApp
    }));
  };

  render() {
    const { listAuth } = this.props;
    return (
      <div className="col-md-12 col-sm-12 borderStyle" style={{ marginTop: '20px' }}>
        <input type="hidden" id="auth" value="addToken" />
        <VerifyOtpEditAuth
          id={this.state.id}
          isDisplay={this.state.showOTP}
          invokeCloseModal={this.closeModalVerifyOtp}
          invokeSuccess={this.verifyOtpSuccess}
        />
        <AuthSelectModal
          showModal={this.state.showModalAdd}
          isAuthPassword={this.state.isAuthPassword}
          isAuthSMS={this.state.isAuthSMS}
          handleClose={this.toggleAuthSelect}
          handleAddToken={this.toggleAddToken}
          handleAddApp={this.handleAddApp}
          handleAddSim={this.toggleAddSim}
          handleAddPhone={this.openModalAddPhone}
          handleAddPassword={this.openModalAddPassword}
          handleAddSmartCA={this.props.addAuthSmartCA}
        />
        <AuthAddToken modalShow={this.state.showAddToken} handleClose={this.toggleAddToken} />
        <AuthAddSim modalShow={this.state.showAddSim} handleClose={this.toggleAddSim} showModalCertInfo={this.toggleCertInfo} />
        <AuthAddApp modalShow={this.state.showAddApp} handleClose={this.toggleAddApp} />
        <CertInfoModal modalShow={this.state.showCertInfo} handleClose={this.toggleCertInfo} />

        <AuthAddPhone
          modalShow={this.state.showAddPhone}
          showFormPhone={this.state.showFormPhone}
          handleClose={this.toggleAddPhone}
          showFormOtp={this.showFormOTP}
          showFormPassword={this.openModalAddPassword}
        />
        <AuthEdit modalShow={this.state.showEditAuth} id={this.state.id} value={this.state.id} handleClose={this.toggleEditAuth} />

        <AuthAddPasswordModal modalShow={this.state.showAddPassword} handleClose={this.toggleAddPassword} />

        <Row style={{ flex: 1, flexDirection: 'row' }}>
          <Col style={{ flex: 4 }}>
            <h4 className="font-weight-bold">Các phương thức xác thực</h4>
          </Col>
          <Col style={{ flex: 6 }}>
            <AvForm id="form-search" onValidSubmit={this.searchAuth}>
              <Row style={{ flex: 1 }}>
                <Col style={{ flex: 10 }}>
                  <AvField name="search" placeholder="Nhập tên phương thức xác thực" />
                </Col>
                <Col style={{ flex: 2 }}>
                  <Button className="btn-register" type="submit">
                    Tìm kiếm
                  </Button>
                </Col>
              </Row>
            </AvForm>
          </Col>
          <Col style={{ flex: 2 }} className="text-center">
            <Link id="linkStyle" to="/" onClick={this.toggleAuthSelect}>
              <FontAwesomeIcon icon={faPlus} color="#4D9235" />
              &nbsp;&nbsp; Thêm mới
            </Link>
          </Col>
        </Row>
        {this.getArrPassAndSMS().length > 0 ? (
          <GroupPassAndSMS
            count={this.props.listAuth.authenticator.length}
            arrPassSMS={this.getArrPassAndSMS()}
            deleteAuth={this.props.deleteAuth}
            resetPassword={this.toggleResetPassword}
            handleActive={this.props.handleActive}
            deleteGroup={this.props.deleteGroup}
            arrUSB={this.getArrUSB()}
            arrKPI={this.getArrKPI()}
            arrSmartCA={this.getArrSmartCA()}
            sendOtp={this.sendOtp}
          />
        ) : null}

        {this.getArrEMAIL().length > 0 ? (
          <GroupEMAIL
            count={this.props.listAuth.authenticator.length}
            arrEMAIL={this.getArrEMAIL()}
            arrUSB={this.getArrUSB()}
            arrPassSMS={this.getArrPassAndSMS()}
            arrKPI={this.getArrKPI()}
            deleteAuth={this.props.deleteAuth}
            deleteGroup={this.props.deleteGroup}
            arrSmartCA={this.getArrSmartCA()}
            sendOtp={this.sendOtp}
          />
        ) : null}

        {this.getArrUSB().length > 0 ? (
          <GroupUSB
            count={this.props.listAuth.authenticator.length}
            arrUSB={this.getArrUSB()}
            arrPassSMS={this.getArrPassAndSMS()}
            arrKPI={this.getArrKPI()}
            deleteAuth={this.props.deleteAuth}
            deleteGroup={this.props.deleteGroup}
            arrSmartCA={this.getArrSmartCA()}
            // userProfile={this.props.userProfile}
          />
        ) : null}

        {this.getArrTOTP().length > 0 ? (
          <GroupTOTP
            count={this.props.listAuth.authenticator.length}
            arrTotp={this.getArrTOTP()}
            arrPassSMS={this.getArrPassAndSMS()}
            arrKPI={this.getArrKPI()}
            deleteAuth={this.props.deleteAuth}
            deleteGroup={this.props.deleteGroup}
            // userProfile={this.props.userProfile}
          />
        ) : null}

        {this.getArrKPI().length > 0 ? (
          <GroupKPI
            count={this.props.listAuth.authenticator.length}
            arrKPI={this.getArrKPI()}
            deleteAuth={this.props.deleteAuth}
            arrPassSMS={this.getArrPassAndSMS()}
            arrUSB={this.getArrUSB()}
            deleteGroup={this.props.deleteGroup}
            arrSmartCA={this.getArrSmartCA()}
            // userProfile={this.props.userProfile}
          />
        ) : null}

        {this.getArrSmartCA().length > 0 ? (
          <GroupSmartCA
            count={this.props.listAuth.authenticator.length}
            arrKPI={this.getArrKPI()}
            deleteAuth={this.props.deleteAuth}
            arrPassSMS={this.getArrPassAndSMS()}
            arrUSB={this.getArrUSB()}
            arrSmartCA={this.getArrSmartCA()}
            deleteGroup={this.props.deleteGroup}

            // userProfile={this.props.userProfile}
          />
        ) : null}

        {/* {listAuth && listAuth.authenticator
          ? listAuth.authenticator.map(auth => (
              <ItemAuth
                key={auth.id}
                auth={auth}
                count={listAuth.authenticator.length}
                deleteAuth={this.props.deleteAuth}
                handleActive={this.props.handleActive}
                resetPassword={this.toggleResetPassword}
              />
            ))
          : null} */}
      </div>
    );
  }
}

const mapStateToPops = (storeState: IRootState) => ({
  responseSignSmartCA: storeState.register.responseSignHashSmartCA
});

const mapDispatchToProps = { signHashSmartCA, reSendOtp, getQRCode };

type StateProps = ReturnType<typeof mapStateToPops>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToPops,
  mapDispatchToProps
)(ListAuth);
